import { colors } from "../../utils/const";
export const styless = {
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 3,
    color: colors.blue,
    py: "20px",
    bgcolor: colors.light_grey,
    position: "sticky",
    top: 0,
    zIndex: "999",
    // boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
  },
};
